import styled from 'styled-components';
export var ArticleSearchResults = styled.div.withConfig({
  displayName: "ArticleSearchstyles__ArticleSearchResults",
  componentId: "pantheon__sc-1y3lrur-0"
})(["width:100%;height:100%;position:relative;max-height:10rem;overflow-y:scroll;"]);
export var ArticleSearchResult = styled.a.withConfig({
  displayName: "ArticleSearchstyles__ArticleSearchResult",
  componentId: "pantheon__sc-1y3lrur-1"
})(["box-sizing:border-box;width:calc(100% - 60px);margin:0 auto;display:block;color:#000000;background-color:#ffffff;:hover{background-color:#f2f2f2;}padding:0.5rem 3.4rem;font-size:1.2rem;font-family:'Lato',sans-serif;text-decoration:none;cursor:pointer;"]);
export var ArticleSearchInput = styled.input.withConfig({
  displayName: "ArticleSearchstyles__ArticleSearchInput",
  componentId: "pantheon__sc-1y3lrur-2"
})(["width:100%;display:block;box-sizing:border-box;height:100%;border:none;font-size:1.5rem;font-family:'Lato',sans-serif;color:#000000;background-color:#f8f8f8;padding:0.7rem 3.4rem;&:focus{outline:none;}"]);
export var ArticleSearchInputContainer = styled.div.withConfig({
  displayName: "ArticleSearchstyles__ArticleSearchInputContainer",
  componentId: "pantheon__sc-1y3lrur-3"
})(["display:flex;margin:0 auto;box-sizing:border-box;width:calc(100% - 60px);height:100%;border:none;font-family:'Lato',sans-serif;color:#000000;background-color:#f8f8f8;"]);
export var ArticleSearchIcon = styled.span.withConfig({
  displayName: "ArticleSearchstyles__ArticleSearchIcon",
  componentId: "pantheon__sc-1y3lrur-4"
})(["position:absolute;display:block;align-self:center;font-size:1.6rem !important;opacity:50%;margin-left:1rem;margin-top:0.2rem;"]);